import * as React from "react";
import {imageBaseUrl} from "config";
import "./index.scss";
import {DocTypes} from "userform/utils";

interface IProps {
    type: DocTypes;
    primaryLabel: string;
    handleFileInput?: (Base64, DocTypes) => void;
    secondaryLabel?: string;
    errorMsg?: string;
}

export const getBase64 = (e, fileSelected, type, handleFileInput) => {
    const files = e.target.files;
    if (files.length > 0) {
        fileSelected(files);
        const fr = new FileReader();
        fr.onload = (evt) => {
            const b64 = window.btoa((evt.target as any).result);
            handleFileInput(b64, type);
        };
        fr.readAsBinaryString(files[0]);
    }
};

export const DocInput = (props: IProps) => {
    const fileInputRef = React.useRef(null);
    const [file, fileSelected] = React.useState(null);
    const style = {
        height: props.secondaryLabel ? 71 : 47,
        backgroundColor: "#434175",
        borderRadius: 6,
        width: "100%",
        color: "#FFFFFF",
    };
    const primaryLabelStyle = {
        fontSize: !props.secondaryLabel ? 18 : 14,
    };

    return (
        <div style={style} onClick={() => fileInputRef.current.click()}>
            <input
                ref={fileInputRef}
                type="file"
                onChange={(e) => getBase64(e, fileSelected, props.type, props.handleFileInput)}
                style={{display: "none"}}
                accept=".pdf,image/*"/>
            <div className="doc-input-container">
                <div className="left-container">
                    {!file ?
                        <div className="label-container">
                            <div style={primaryLabelStyle} className="primary-label">
                                {props.primaryLabel}
                            </div>
                            {props.secondaryLabel ?
                                <div className="secondary-label">
                                    {props.secondaryLabel}
                                </div> : null}
                        </div>
                        :
                        <div className="file-selected-container">
                            <div className="icon">
                                <img src={`${imageBaseUrl}/img/consent/green_tick.png`} alt="upload"/>
                            </div>
                            <div className="selected-text">
                                {file[0].name}
                            </div>
                        </div>
                    }
                </div>
                <div className="right-container">
                    <img src={`${imageBaseUrl}/img/consent/upload_icon.png`} alt="upload"/>
                </div>
            </div>
        </div>
    );
};

export default DocInput;
